import { Layout } from '@design-systems/canvas-ui'
import { useFilteredNavigationItems } from './hooks/useFilteredNavigationItems'

export const SideNavigation = () => {
  const sideNavItems = useFilteredNavigationItems()

  return <Layout.SideNav items={sideNavItems} />
}
